<template>
	<div class="tab-body">
		<div class="search">
			<el-form ref="form" :model="searchParams" label-width="80px">
				<el-row>
					<el-col :span="4">
						<el-form-item label="招生学年">
							<el-input v-model="searchParams.zsyear"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="4">
						<el-form-item label="学校名称">
							<el-input v-model="searchParams.name"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="4">
						<el-form-item label="专业">
							<el-input v-model="searchParams.subject"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="5">
						<el-form-item label="层次">
							<!-- <el-input v-model="searchParams.level"> -->
							<select-option-dictionary v-model="searchParams.level" dkey="xli-level" :multiple="false"
								:stringMode="true"></select-option-dictionary>
							<!-- </el-input> -->
						</el-form-item>
					</el-col>
					<div class="search-btn">
						<el-button type="primary" @click="search">搜索</el-button>
						<el-button @click="clearSearchVal">清空</el-button>
					</div>
				</el-row>
			</el-form>
		</div>
		<div class="operator">
			<el-button type="primary" v-has-permission-code-and="'003000000005'" size="mini"
				@click="toSave()">添加</el-button>
		</div>
		<div class="dataTable autoFlex" v-if="listData">
			<el-table class="table" style="width: 100%;" :data="listData.records" stripe border height="auto"
				@selection-change="selectionChange">
				<el-table-column type="expand">
					<template slot-scope="props">
						<el-table class="table" style="color: rgb(117, 110, 179); font-size: 12px;"
							:data="props.row.children" stripe border height="auto" :show-header="false">
							<el-table-column prop="tp" width="100"></el-table-column>
							<el-table-column prop="nm" width="200"></el-table-column>
							<el-table-column width="100">
								<template slot-scope="props2">
									{{ props2.row.scnt ? props2.row.scnt : 0 }}
									<!-- {{ props2.row.scnt ? props2.row.scnt : 0 }} -->
								</template>
							</el-table-column>
							<el-table-column prop="ks" width="120"></el-table-column>
							<el-table-column prop="cd" width="100"></el-table-column>
							<el-table-column prop="nm">
								<template slot-scope="props2">
									{{ props2.row.dj2?(props2.row.dj?"第一年":''):"" }}学费：{{ props2.row.dj?props2.row.dj:"" }}元； 
									{{ props2.row.dj2? "第二年学费："+props2.row.dj2+"元;":'' }}
									{{ props2.row.dj3? "第三年学费："+props2.row.dj3+"元;":'' }}合计:
									{{ (props2.row.dj ? props2.row.dj : 0) *1+ (props2.row.dj2 ? props2.row.dj2 : 0) *1+(props2.row.dj3 ? props2.row.dj3 : 0)  *1}}元。
								</template>
							</el-table-column>
						</el-table>
					</template>
				</el-table-column>

				<!-- <el-table-column type="selection" width="55" fixed="left"></el-table-column> -->
				<el-table-column prop="zsyear" width="100" label="招生学年"></el-table-column>
				<el-table-column prop="skname" width="200" label="学校名称"></el-table-column>
				<el-table-column prop="stuCnt" label="报考人数" width="100">
					<template slot-scope="scope">
						<div size="mini"> {{ scope.row.stuCnt ? scope.row.stuCnt : 0 }}</div>
					</template>
				</el-table-column>
				<el-table-column prop="level" width="120" label="层次"></el-table-column>
				<el-table-column prop="code" width="100" label="学校代码"></el-table-column>
				<el-table-column prop="starttm" width="120" label="开始时间"></el-table-column>
				<el-table-column prop="endtm" width="120" label="结束时间"></el-table-column>

				<el-table-column prop="cnt" width="100" label="专业数量">
					<template slot-scope="scope">
						<div size="mini">{{ scope.row.children ? scope.row.children.length : 0 }}</div>
					</template>
				</el-table-column>
				<el-table-column prop="zsimg" width="90" label="证书样本">
					<template slot-scope="scope">
						{{ scope.row.zsimg ? '有' : '' }}
					</template>
				</el-table-column>
				<el-table-column label="操作" width="300px">
					<template slot-scope="scope">
						<div class="dataTable-operator">
							<el-button size="mini" v-has-permission-code-and="'00300000'"
								@click="toDetail(scope.$index, scope.row)">详情</el-button>
							<el-button size="mini" v-has-permission-code-and="'003000000005'"
								@click="toUpdate(scope.$index, scope.row)">编辑</el-button>
							<el-button size="mini" v-has-permission-code-and="'00300000'"
								@click="toSubject(scope.row)">配置</el-button>
							<el-button size="mini" v-has-permission-code-and="'003000000000'" type="danger"
								@click="remove(scope.$index, scope.row)">删除</el-button>
						</div>
					</template>
				</el-table-column>
			</el-table>
			<div class="pageBar">
				<el-pagination @size-change="sizeChange" @current-change="currentChange" :total="listData.total"
					:page-size="page.size" :current-page="page.current" :layout="this.$constant.page.layout"
					:page-sizes="this.$constant.page.pageSizes"></el-pagination>
			</div>
		</div>
		<edit ref="edit"></edit>
		<subject ref="subject"></subject>
	</div>
</template>

<script>
import subject from './subject.vue';
import edit from './edit.vue';
import api from '@/api/xueli/xlschool.js';
import caches from 'util/caches.js';
import selectOptionDictionary from "@/components/biz/selectOptionDictionary/selectOptionDictionary.vue";
export default {
	name: 'xlschool',
	components: {
		edit,
		subject,
		selectOptionDictionary
	},
	//页面数据
	data() {
		return {
			sjsNumber: '',
			searchParams: {},
			isShowMoreSearch: false,
			listLoading: false,
			listData: [],
			selected: [],
			page: new this.$constant.pageObj(),

		};
	},
	//页面操作
	methods: {

		//获取数据
		list() {
			this.listLoading = true;
			let params = this.$utils.merger(this.searchParams, this.page);
			api.list(params, response => {
				//通过vue的双向绑定渲染数据
				this.listData = response.data;
				this.listData.records.forEach(rcd => {
					if (rcd.subjects) {
						rcd.subjects = JSON.parse(rcd.subjects)
					}
				});
				this.listLoading = false;
			})
		},
		//去添加
		toSave() {
			this.$refs.edit.open({}, '添加学历高校');
		},
		//去编辑
		toUpdate(index, row) {
			let editParameter = {
				id: row.id
			};
			this.$refs.edit.open(editParameter, '编辑');
		},	//去配置专业
		toSubject(row) {
			this.$refs.subject.open(row, '配置 ' + row.skname + " 专业");
		},
		//去详情
		toDetail(index, row) {
			let detailParameter = {
				id: row.id
			};
			this.$refs.edit.open(detailParameter, '详情', true);
		},
		//删除
		remove(index, row) {
			let parameter = {
				ids: row.id
			}
			this.$utils.confirm.warning('提示', '确定删除吗？', () => {
				api.remove(
					parameter,
					response => {
						this.$utils.msg.success(response.msg);
						this.list();
					},
					response => {
						this.$utils.msg.warning(response.msg);
					}
				);
			});
		},
		//批量删除
		batchRemove() {
			if (!this.selected || this.selected.length == 0) {
				this.$utils.msg.info('请选择至少一行');
				return;
			}
			let parameter = {
				ids: this.selected
			};
			this.$utils.confirm.warning('提示', '确定删除吗？', () => {
				api.remove({
					ids: this.selected
				},
					response => {
						this.$utils.msg.success(response.msg);
						this.list();
					},
					response => {
						this.$utils.msg.warning(response.msg);
					}
				);
			});
		},
		//改变选择项
		selectionChange(val) {
			//清空
			this.selected = [];
			for (let item of val) {
				this.selected.push(item.id);
			}
		},
		//改变每页显示数量
		sizeChange(val) {
			this.page.size = val;
			this.list();
		},
		//改变现在的页码
		currentChange(val) {
			this.page.current = val;
			this.list();
		},

		//搜索
		search() {
			this.list();
		},
		//清空搜索框
		clearSearchVal() {
			this.searchParams = {};
		}
	},
	// vue【生命周期】：装载完毕
	mounted() {
		this.list();
		// console.log(caches.permissionCode)
	}
};

</script>

<style lang="scss" scoped="scoped">
@import '~common/custom/css/common.scss';

.demo-table-expand {
	font-size: 0;
	display: flex;

}

.item .el-form-item__label {
	width: 90px;
	color: #8e9fb6;
}


.demo-table-expand .el-form-item {
	margin-right: 0;
	margin-bottom: 0;
	width: 50%;

}

.demo-table-expand .item div {
	color: #99a9bf;
}

.demo-table-expand .nm {
	width: 270px;
}

.demo-table-expand .tp {
	width: 200px;
}

.demo-table-expand .cs {
	width: 500px;
}

.demo-table-expand .ks {
	width: 200px;
}

.demo-table-expand .el-form-item span {

	display: flex;
	flex-direction: column;
}
</style>

